/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row } from 'reactstrap'

const PendingProductStatus = ({ item }) => {
  const [reviewStatus, setReviewStatus] = useState({
    ReviewerOneFN: '',
    ReviewerOneLN: '',
    ReviewOneStatus: '',
  })

  useEffect(() => {
    if (item) {
      console.log('item is: ' + JSON.stringify(item))
      const { ReviewerOneFN, ReviewerOneLN, ReviewOneApproved } = item
      setReviewStatus({
        ReviewerOneFN: ReviewerOneFN ?? '',
        ReviewerOneLN: ReviewerOneLN ?? '',
        ReviewOneStatus: ReviewOneApproved ?? '',
      })
    }
  }, [item])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>Reviewer One</p>
          <Input
            name="ReviewerOne"
            value={
              reviewStatus.ReviewerOneFN + ' ' + reviewStatus.ReviewerOneLN
            }
            disabled
          />
          <br />
          <p>Review One Status</p>
          <Input
            name="ReviewOneStatus"
            defaultValue={reviewStatus.ReviewOneStatus}
            disabled
          />
        </FormGroup>
      </Col>
    </Row>
  )
}

export default PendingProductStatus
